import { createDataSourceTile } from 'ui/datasource-tile/datasource-tile';

import type { DataSourceFlavor } from 'cadenza/repository/data-source-flavor';
import type { DataSourceType } from 'cadenza/repository/model/data-source-type.gen';

export interface DataSourceLabelOptions {
  dataSourcePrintName: string;
  dataSourceType: DataSourceType;
  dataSourceFlavor?: DataSourceFlavor;
}

export function createDataSourceLabel(options: DataSourceLabelOptions) {
  return createDataSourceTile(options.dataSourcePrintName, options.dataSourceType, options.dataSourceFlavor, {
    displayMode: 'singleLine',
    styleClass: 'ellipsis',
  });
}
